import React, { Component, type ReactNode, type ErrorInfo } from 'react'
import { Layout } from 'antd'

import { WppLayoutErrorPlaceholder } from './LayoutErrorPlaceholder'

const { Content } = Layout

interface IProps {
  children: ReactNode
  onError?: (error: Error, errorInfo: ErrorInfo) => void
}

interface IState {
  hasError: boolean
}

export class WppLayoutErrorBoundary extends Component<IProps, IState> {
  private unlisten

  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidMount() {
    /* istanbul ignore next */
    const historyListener = () => {
      if (this.state.hasError) {
        this.setState({
          hasError: false
        })
      }
    }
    addEventListener('popstate', historyListener)
    // eslint-disable-next-line functional/immutable-data
    this.unlisten = () => removeEventListener('popstate', historyListener)
  }

  componentDidCatch(error, info) {
    this.setState({
      hasError: true
    })

    /* istanbul ignore else */
    if (this.props.onError) {
      this.props.onError(error, info)
    }
  }

  componentWillUnmount() {
    this.unlisten()
  }

  render() {
    if (this.state.hasError) {
      return (
        <Layout>
          <Content className='wpp-layout__error-screen'>
            <WppLayoutErrorPlaceholder />
          </Content>
        </Layout>
      )
    }

    return this.props.children
  }
}
